import { useContext } from "react";
import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { GetNewsService } from "@/features/news/services/get-news-service";


export const useGetNews = () => {
  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);
  const getNewsService = new GetNewsService();

  // お知らせ一覧取得
  const getNews = async () => {
    try {
      const resNews = await getNewsService.getNews();
      return resNews;
    } catch (error) {
      // エラーハンドリング
      console.log("getNews", error);
    } finally {
      //
    }
  };

  return {
    getNews: errorHandledAsync(getNews, setError),
  };
};
